<template>
  <div></div>
</template>

<script>
import loginAction from "@/utils/UserAction/login";
import { mapGetters } from "vuex";
import { ENV_CONFIG } from '@/config';

export default {
  data() {
    return {
      loginInstance: null,
    };
  },
  computed: {
    ...mapGetters({
      jumpUrls: "jumpUrls",
      isOpenLimitedMode: "isOpenLimitedMode",
    }),
  },
  mounted() {
    this.initLoginCenter();
    this.$Bus.$on("bus-showLogin", this._toggleLogin);
    this.$Bus.$on("bus-showPcLogin", this._togglePcLogin);
  },
  beforeDestroy() {
    this.$Bus.$off("bus-showLogin", this._toggleLogin);
  },
  methods: {
    _toggleLogin(bool) {
      if (bool) {
        // v1
        if (window.jsApi && window.JSBridge) {
          window.jsApi.loginRequest();
        }
        // v2
        if (window._gdyJsApi && this.isOpenLimitedMode) {
          window._gdyJsApi.loginRequest();
        }
        if (!this.isOpenLimitedMode) {
          if (!this.loginInstance) {
            this.$toast("登录模块加载失败，3秒后为您跳转到登录页");
            setTimeout(() => {
              window.location.href = this.jumpUrls.login;
            }, 3000);
            return;
          }
          this.loginInstance.show();
        }
      }
    },
    _togglePcLogin(bool) {
      if (bool) {
        // v1
        if (window.jsApi && window.JSBridge) {
          window.jsApi.loginRequest();
        }
        // v2
        if (window._gdyJsApi && this.isOpenLimitedMode) {
          window._gdyJsApi.loginRequest();
        }
        if (!this.isOpenLimitedMode) {
          window.location.href = this.jumpUrls.login;
        }
      }
    },
    // 云平台登录模块初始化
    initLoginCenter() {
      if (!window.LoginCenter) return;
      const isCname = !window.location.href.includes(
        `//${ENV_CONFIG.CUSTOMER_DOMAIN}`
      )
      const state = isCname ? document.domain : ''
      const wxPcRedirect = isCname
        ? window.location.href.replace(
          /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62}|(:[0-9]{1,4}))+\.?/,
          `${ENV_CONFIG.CUSTOMER_DOMAIN}`
        )
        : window.location.href
      // eslint-disable-next-line no-undef
      this.loginInstance = LoginCenter({
        target: document.body,
        props: {
          uin: this.$route.query.uin,
          zIndex: 100000,
          backUrl: encodeURIComponent(window.location.href),
          wxPcRedirect,
          state,
          serviceAgreement: `//${ENV_CONFIG.OSS_DOMAIN}/staticPages/agreement_user.html`,
          privacyAgreement: `//${ENV_CONFIG.OSS_DOMAIN}/staticPages/agreement_privacy.html`,
          successCallback: ({ type, response }) => {
            if (type === "recover") {
              this.$toast("密码修改成功!");
              setTimeout(() => {
                this.loginInstance.hide();
              }, 500);
              return;
            }
            this.$toast("登录成功!");
            if (type === "phone") {
              this.loginInstance.hide();
            }
            if (type === "password") {
              this.loginInstance.hide();
            }
            const query = this.$route.query;
            const onFinished = () => {
              delete query.token;
              if (type === "weixinPc" && "code" in query) {
                delete query.code;
                this.$router.replace({
                  path: this.$route.path,
                  query,
                });
              }
              if (type === "alipay" && "auth_code" in query) {
                delete query.auth_code;
                this.$router.replace({
                  path: this.$route.path,
                  query,
                });
              }
            };
            // const loginAction = require("@/utils/UserAction/login").default;
            loginAction.call(this, { token: response.data, onFinished });
          },
          failCallback: ({ response }) => {
            this.$toast(response.errorMessage);
          },
        },
        onMount: () => {
          console.log("已挂载");
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
